import toPairs from 'lodash/toPairs';

/**
 * Tests if Internet Explorer v >= 10 is being used.
 */
export const isIE = () => window.navigator.msPointerEnabled;

/**
 * Add here the check methods above. The key is used to set the class in the body.
 */
const browserChecksMap = {
  IE: isIE,
};

const browserChecks = () => {
  toPairs(browserChecksMap).forEach(([browserName, browserCheck]) => {
    const browserClassname = browserCheck()
      ? `is-${browserName}`
      : `is-not-${browserName}`;
    document.body.classList.add(browserClassname);
  });
};

export default browserChecks;
